<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Ingresa datos personales':'Edita los datos personales'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col form-group">
							<label for="firstName" class="form-label">Nombres <span class="required">*</span></label>
							<input type="text" name="firstName" placeholder="Ingresa los nombres"
								[(ngModel)]="newEmployee.nombre" id="firstName" class="form-control">
						</div>
						<div class="col form-group">
							<label for="lastName" class="form-label">Apellidos <span class="required">*</span></label>
							<input type="text" name="lastName" placeholder="Ingresa los apelidos"
								[(ngModel)]="newEmployee.apellido" id="lastName" class="form-control">
						</div>

						<div class="col form-group">
						<label for="registerDate" class="form-label">Fecha Alta <span class="required">*</span></label>
						<input
							type="date"
							name="registerDate"
							id="registerDate"
							[(ngModel)]="newEmployee.registerDate"
							class="form-control"
						>
						</div>
						
						<div class="col form-group">
						<label for="dischargeDate" class="form-label">Fecha Baja</label>
						<input
							type="date"
							name="dischargeDate"
							id="dischargeDate"
							[(ngModel)]="newEmployee.dischargeDate"
							[max]="today"
							class="form-control"
						>
						</div>
						
						<div class="col form-group">
							<label for="gender" class="form-label">Género <span class="required">*</span></label>
							<select name="gender" id="gender" [(ngModel)]="newEmployee.genero" class="form-select">
								<option value="undefined">Selecciona un género</option>
								<option value="H">Masculino</option>
								<option value="M">Femenino</option>
							</select>
						</div>
						<div class="col form-group">
							<label for="birthday" class="form-label">Fecha de Nacimiento <span
									class="required">*</span></label>
							<input type="date" name="birthday" id="birthday" [(ngModel)]="newEmployee.nacimiento"
								class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col form-group">
							<label for="citizenship" class="form-label">Nacionalidad <span
									class="required">*</span></label>
							<select name="citizenship" id="citizenship" [(ngModel)]="newEmployee.citizenship"
								class="form-select">
								<option [ngValue]="undefined">Selecciona una nacionalidad</option>
								<option *ngFor="let citizenship of citizenships" value="{{citizenship.id}}">
									{{citizenship.citizenship}}</option>
							</select>
						</div>
						<div class="col form-group">
							<label for="id" class="form-label">Número de Identificación personal <span
									class="required">*</span></label>
							<input type="text" name="id" placeholder="Ingresa el número"
								[(ngModel)]="newEmployee.identificacion" id="id" class="form-control">
						</div>
						<div class="col form-group">
							<label for="license" class="form-label">Licencia de conducir</label>
							<select name="license" id="license" [(ngModel)]="newEmployee.licencia" class="form-select">
								<option [ngValue]="undefined">Elige una opción</option>
								<option value="N">No poseo licencia de conducir</option>
								<option value="C">Liviana</option>
								<option value="B">Comercial</option>
								<option value="A">Profesional</option>
								<option value="M">Motocicleta</option>
								<option value="E">Maquinaria Agrícola</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col form-group">
							<label for="celular" class="form-label">Teléfono Celular</label>
							<input type="text" name="celular" placeholder="Ingresa el celular"
								[(ngModel)]="newEmployee.celular" id="celular" class="form-control">
						</div>
						<div class="col form-group">
							<label for="residential" class="form-label">Teléfono Residencial</label>
							<input type="text" name="residential" placeholder="Ingresa el teléfono residencial"
								[(ngModel)]="newEmployee.telefono" id="residential" class="form-control">
						</div>
						<div class="col form-group">
							<label for="email" class="form-label">Correo Electrónico</label>
							<input type="text" name="email" placeholder="Ingresa el correo"
								[(ngModel)]="newEmployee.mail" id="email" class="form-control">
						</div>
						<div class="col form-group">
							<label for="visa" class="form-label">Visa Americana Vigente</label>
							<select name="visa" id="visa" [(ngModel)]="newEmployee.visa" class="form-select">
								<option value="true">Si</option>
								<option value="false">No</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col form-group">
							<label for="address" class="form-label">Dirección <span class="required">*</span> </label>
							<input type="text" name="address" placeholder="Ingresa la dirección"
								[(ngModel)]="newEmployee.direccion" id="address" class="form-control">
						</div>
						<div class="col form-group">
							<label for="zone" class="form-label">Zona</label>
							<input type="number" name="zone" placeholder="Ingresa la zona"
								[(ngModel)]="newEmployee.zona" id="zone" class="form-control">
						</div>
						<div class="col form-group">
							<label for="country" class="form-label">Pais <span class="required">*</span></label>
							<select name="country" id="country" (change)="setDepartments()"
								[(ngModel)]="newEmployee.pais" class="form-select">
								<option [ngValue]="undefined">Elige un pais</option>
								<option *ngFor="let country of countries" [ngValue]="country.id">{{country.name}}
								</option>
							</select>
						</div>
						<div class="col form-group" *ngIf="newEmployee.pais">
							<label for="department" class="form-label">Departamento <span
									class="required">*</span></label>
							<select name="department" id="department" (change)="setTowns()"
								[(ngModel)]="newEmployee.departamento" class="form-select">
								<option *ngFor="let department of departments" value="{{department.id}}">
									{{department.name}}
								</option>
							</select>
						</div>
						<div class="col form-group" *ngIf="newEmployee.departamento">
							<label for="town" class="form-label">Municipio <span class="required">*</span></label>
							<select name="town" id="town" [(ngModel)]="newEmployee.municipio" class="form-select">
								<option *ngFor="let town of towns" value="{{town.id}}">{{town.name}}</option>
							</select>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'crear la contratación':'guardar los cambios'}}
					</p>
				</div>
				<div class="modal-footer" style="display: flex; justify-content: space-between; margin-top: 1em;">
					<a href="https://s3-us-west-2.amazonaws.com/inin-templates/inERP/rrhh/plantilla_rrhh_personal.csv" class="btn insend_btn" style="margin-top: 15px">
                        <i class="fa fa-download"></i> Descargar Plantilla
                    </a>
					<button class="btn btn-info" (click)="uploadCSV()">
						<i *ngIf="!uploadingCSV" class="fa fa-upload"></i>
						<span *ngIf="uploadingCSV" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
						CARGAR POR CSV
					</button>
					<button class="btn btn-success" [disabled]="!canSave" (click)="hireEmployee()">
						<i *ngIf="!hiring" class="fa fa-save"></i>
						<span *ngIf="hiring" class="spinner-border spinner-border-sm" aria-hidden="true"></span>REGISTRAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>